import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './stil/tokeni.css'
import './stil/aplikacija.css'
import { App } from './App'

const koren = document.getElementById('koren')
if (!koren) throw new Error('Nema #koren u index.html')

createRoot(koren).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
